import { connect } from 'react-redux';
import {
  individualContributorsSelector,
  selectedTeamContributorsSelector,
  contributorsByIdSelector
} from 'state/selectors/contributors';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import { selectTeamId } from 'state/actions';
import {
  isProjectManagementConnectedSelector,
  pmIntegrationSelector
} from 'state/selectors/sensors-authorizations';
import { isTeamLicenseSelector } from 'state/selectors/license';
import {
  selectedTeamProject,
  selectedTeamContainerIds
} from 'state/selectors/projects';
import {
  getTeams,
  createTeam,
  toggleModal,
  toggleSnackBar,
  DateSelectionChanged
} from 'state/callers';
import { myAccountSelector } from 'state/selectors/account';
import PulseRouter from './PulseRouter';
import { currentIterationSelector } from 'state/selectors/iterations-picker';

const mapStateToProps = state => {
  const { iterations } = state;
  return {
    iterations,
    contributors: individualContributorsSelector(state),
    contributorsById: contributorsByIdSelector(state),
    currentTeam: selectedTeamSelector(state),
    isProjectManagementConnected: isProjectManagementConnectedSelector(state),
    pmSensor: pmIntegrationSelector(state),
    selectedTeamContributors: selectedTeamContributorsSelector(state),
    selectedTeamProject: selectedTeamProject(state),
    isTeamLicense: isTeamLicenseSelector(state),
    myAccount: myAccountSelector(state),
    teamPMEntitiesIds: selectedTeamContainerIds(state),
    currentIteration: currentIterationSelector(state)
  };
};

const mapDispatchToProps = {
  toggleModal,
  toggleSnackBar,
  createTeam,
  selectTeamId,
  DateSelectionChanged,
  getTeams
};

export default connect(mapStateToProps, mapDispatchToProps)(PulseRouter);
